import { useTranslations } from "next-intl";

import { Badge } from "@/components/ui/badge";
import { PASSWORD_MIN_LENGTH } from "@/schemas";

interface PasswordCriteriaProps {
    password: string;
}

export const PasswordCriteria = ({ password }: PasswordCriteriaProps) => {
    const t = useTranslations("auth.passwordCriteria");

    const criteria = [
        {
            regex: new RegExp(`.{${ PASSWORD_MIN_LENGTH },}`),
            label: t("minCharacters", { min: PASSWORD_MIN_LENGTH }),
        },
        {
            regex: /[a-z]/,
            label: t("lowercaseLetter"),
        },
        {
            regex: /[A-Z]/,
            label: t("uppercaseLetter"),
        },
        {
            regex: /[0-9]/,
            label: t("number"),
        },
        {
            regex: /[^a-zA-Z0-9]/,
            label: t("symbol"),
        },
    ];

    return (
        <div className="flex flex-wrap gap-2">
            {criteria.map((criterion, index) => (
                <Badge
                    key={ index }
                    variant={ criterion.regex.test(password) ? "success" : "default" }
                    className="cursor-default select-none px-2 py-1"
                >
                    {criterion.label}
                </Badge>
            ))}
        </div>
    );
};